import {Component, ContentChild, ElementRef, Input, OnInit, TemplateRef} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ReviewActionService} from '../../review-action-service';
import {ExcProgbarData} from '../../app-exc-progbar/app-exc-progbar.component';

@Component({
  selector: 'app-pending-audit-item',
  templateUrl: './pending-audit-item.component.html',
  styles: []
})
export class PendingAuditItemComponent extends ExcTranslation implements OnInit {

  @Input('pendingAudit') pendingAudit: any;
  @ContentChild('sideMenu') sideMenuRef: TemplateRef<ElementRef>;
  @Input('smallItem') smallItem = false;
  constructor(private excDss: DefaultSettingsService) {
    super();
  }
  ngOnInit() {
  }
  getSelfcheckTooltip() {
    const txt = 'Selfcheck';
    let add = '';
    if (this.pendingAudit.AuditType === 35) {
      add = this.getGlobal('Documents');
    }
    if (this.pendingAudit.AuditPartialResult === true) {
      if (add === '') {
        add = this.getGlobal('PartialResults');
      } else {
        add = add + ', ' + this.getGlobal('PartialResults');
      }
    }
    return txt + (add === '' ? '' : ' (' + add + ')');
  }
  getAvatarTooltip() {
    if (this.pendingAudit.AuditIsGroup === true) {
      return this.getGlobal('GroupAudit');
    } else {
      if (this.pendingAudit.IsLinked === true) {
        return this.getGlobal('LinkedAudits');
      } else {
        if (this.pendingAudit.AuditType !== 16 && this.pendingAudit.AuditType !== 35) {
          return this.getGlobal('Floorcheck');
        } else {
          return this.getSelfcheckTooltip();
        }
      }
    }
  }
  getAvatarClass() {
    if (this.pendingAudit.IsLinked === true) {
      return 'fa-link th-warning ch-both';
    } else {
      if (this.pendingAudit.AuditType === 16) {
        if (this.pendingAudit.AuditPartialResult === true) {
          return 'fa-mobile th-danger';
        } else {
          return this.pendingAudit.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary';
        }
      } else if (this.pendingAudit.AuditType === 35) {
        if (this.pendingAudit.AuditPartialResult === true) {
          return 'fa-scanner-image th-danger';
        } else {
          return this.pendingAudit.AuditIsPicked ? 'fa-scanner-image th-warning' : 'fa-scanner-image th-secondary';
        }
      } else {
        return this.pendingAudit.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
      }
    }
  }
}
